import { ITemplate } from '@/types'

export const getTemplateName = (template: ITemplate) => {
  switch (true) {
    case template.__component === 'template.guide':
      return 'guide'
    case template.__component === 'template.week-ahead':
      return 'week-ahead'
    case template.__component === 'template.artist-spotlight':
      return 'artist-spotlight'
    case template.__component === 'template.good-things-come-in-three':
      return 'good-things-come-in-three'
    default:
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      throw new Error(`Unknown template: ${(template as any).__component}`)
  }
}
